import PropTypes from 'prop-types';
import { twJoin } from 'tailwind-merge';

import Box from 'shopper/components/Box';

const CommentsListSection = ({ children, className }) => (
  <Box
    as="section"
    className={twJoin('flex w-full gap-4 bg-neutral-high-100', className)}
  >
    {children}
  </Box>
);

CommentsListSection.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
};

export default CommentsListSection;
